import merge from '../../utilities/merge'
import { actionTypeDefinitions } from '../actionTypes'
import { workflow } from '../actionTypes/generators'
import { workflowActionCreatorsForName } from './generators'

// TODO: rename to sagaActionCreators

// 6. create the hierarchical structure of workflow actionCreators for use in process sagas
const actionWorkflows = merge(
	Object.keys(actionTypeDefinitions)
		.filter(name => actionTypeDefinitions[name] === workflow)
		.map(name => workflowActionCreatorsForName(name))
)

// 7. export/import as actionWorkflows
export default actionWorkflows

global.KF = { ...global.KF, actionWorkflows }



// WEBPACK FOOTER //
// ./src/redux/actionWorkflows/index.js